import React, {useRef} from 'react';
import propTypes from 'prop-types';
import {useSelector} from "react-redux";

import * as _ from 'lodash'
import {REGISTRO} from "../../costanti";
import {dayJS} from "../../applicationConf";
import {utilityFunction} from "../../fanctionUtility";
import {mapMesiValidati} from "../../customSelector";


const DropDownMonth = (props) => {

    let groupRef = useRef(null);
    let menuRef = useRef(null);
    let buttonRef = useRef(null);

    const corso = useSelector(state => state.corso.corso);
    const estremi = useSelector(state => state.pianificazioneCalendario.estremi);
    const $$mapMesiValidati = useSelector(mapMesiValidati);

    const closeMenuRightMonths = React.useCallback((e) => {

        const isMenuShown = groupRef.current.classList.contains('show') || menuRef.current.classList.contains('show');
        const isButtonClicked = buttonRef.current.contains(e.target);
        const isMenuPresent = menuRef.current !== null;
        const isGroupPresent = groupRef.current !== null;
        const isBlocked = e.target.classList.contains('text-muted');

        if ((!isBlocked && isMenuShown && isGroupPresent && isMenuPresent) || isButtonClicked) {
            groupRef.current.classList.toggle('show');
            menuRef.current.classList.toggle('show');
        }
    }, [])

    React.useEffect(() => {
        window.addEventListener('click', closeMenuRightMonths, true);
        return () => {
            window.removeEventListener('click', closeMenuRightMonths, true);
        }
    }, [closeMenuRightMonths]);

    const periodoCompetenzaObj = props.type === REGISTRO ?
        utilityFunction(corso.dataInizio, corso.dataFine != null ? corso.dataFine : null)
            .map(completeDay => (
                {
                    yearMonth: dayJS(completeDay, 'YYYY-M-D').format('YYYY-MM'),
                    month: dayJS(completeDay, 'YYYY-M-D').format('MMMM'),
                    year: dayJS(completeDay, 'YYYY-M-D').year()
                }
            ))
        : utilityFunction(estremi.meseInizio, estremi.meseFine)
            .map(completeDay => (
                {
                    yearMonth: dayJS(completeDay, 'YYYY-M-D').format('YYYY-MM'),
                    month: dayJS(completeDay, 'YYYY-M-D').format('MMMM'),
                    year: dayJS(completeDay, 'YYYY-M-D').year()
                }
            ));

    const [periodoCompetenzaObjState] = React.useState(periodoCompetenzaObj);

    const checkValidMonth = (monthTarget) => {
        let validMonth = true;

        $$mapMesiValidati.forEach((arrayMonthValidated, _) =>
            validMonth = arrayMonthValidated.length > 0 && arrayMonthValidated.map(x => x.yearMonth).includes(monthTarget.yearMonth) && validMonth);

        return validMonth;
    }

    const checkMonthInPeriod = (monthTarget) => {

        const checkInPeriod = periodoCompetenzaObjState.find(x => dayJS(x.yearMonth, ['YYYY-MM', 'YYYY-M']).isSame(dayJS(monthTarget.yearMonth, ['YYYY-MM', 'YYYY-M']), 'month'));
        const checkIsToday = props.type === REGISTRO ?
            dayJS(monthTarget.yearMonth, ['YYYY-MM', 'YYYY-M']).isSame(dayJS(dayJS().format('YYYY-M')), 'month') :
            dayJS(monthTarget.yearMonth, ['YYYY-MM', 'YYYY-M']).isSame(dayJS(dayJS(props.currentMonth, 'YYYY-M-D').format('YYYY-MM')), 'month');

        if (checkInPeriod != null) {
            if (!checkIsToday) {
                return (
                    <div key={dayJS(monthTarget.yearMonth, ['YYYY-MM', 'YYYY-M']).unix()}
                         className="dropdown-item d-flex flex-wrap flex-row align-items-center justify-content-between"
                         style={{textTransform: 'capitalize', whiteSpace: 'normal', cursor: 'pointer'}}
                         onClick={() => props.selectMonth(monthTarget.yearMonth)}>

                        {dayJS(monthTarget.yearMonth, ['YYYY-MM', 'YYYY-M']).format('YYYY - MMMM')}

                    </div>
                )
            } else {
                return (
                    <div key={dayJS(monthTarget.yearMonth, ['YYYY-MM', 'YYYY-M']).unix()}
                         className={`dropdown-item d-flex flex-row flex-wrap align-items-center justify-content-between ${props.type !== REGISTRO ? " text-white bg-primary" : ""}`}
                         style={{textTransform: 'capitalize', whiteSpace: 'normal', cursor: 'pointer'}}
                         onClick={() => props.selectMonth(monthTarget.yearMonth)}>

                        {dayJS(monthTarget.yearMonth, ['YYYY-MM', 'YYYY-M']).format('YYYY - MMMM')}

                    </div>
                );
            }

        } else {
            return (
                <div className="dropdown-item text-muted d-flex"
                     key={dayJS(monthTarget.yearMonth, ['YYYY-MM', 'YYYY-M']).unix()}
                     style={{textTransform: 'capitalize', cursor: 'not-allowed', whiteSpace: 'normal'}}>

                    {dayJS(monthTarget.yearMonth, ['YYYY-MM', 'YYYY-M']).format('YYYY - MMMM')}

                </div>
            );
        }
    };

    const buildDropDownMenu = () => {

        if (props.type === REGISTRO) {
            const arrayOfMonthOfCurrentYear = Array.apply(0, Array(12))
                .map((_, i) => ({
                    yearMonth: dayJS().month(i).format('YYYY-MM'),
                    month: dayJS().month(i).format('MMMM'),
                    year: dayJS().year()
                }));

            const diff = _.differenceBy(periodoCompetenzaObjState, arrayOfMonthOfCurrentYear, 'yearMonth');
            const allMonths = _.sortBy([...arrayOfMonthOfCurrentYear, ...diff], 'yearMonth');

            return allMonths.map(monthTarget => checkMonthInPeriod(monthTarget));
        } else {
            return periodoCompetenzaObjState.map(monthTarget => checkMonthInPeriod(monthTarget));
        }
    };

    return (
        <div className="btn-group dropright" ref={groupRef}>
            <button type="button"
                    className="btn btn-primary dropdown-toggle"
                    style={{textTransform: 'capitalize'}}
                    disabled={props.disabled}
                    ref={buttonRef}
            >
                {dayJS(props.currentMonth, 'YYYY-M').format('MMMM - YYYY')}&nbsp;
            </button>
            <div className="dropdown-menu" ref={menuRef}
                 style={{maxHeight: '200px', overflowX: 'hidden', overflowY: 'auto', width: '220px'}}>

                {buildDropDownMenu()}

            </div>
        </div>
    )
};

DropDownMonth.propTypes = {
    currentMonth: propTypes.string.isRequired,
    estremi: propTypes.shape({
        meseInizio: propTypes.string,
        meseFine: propTypes.string,
        meseDaVisualizzare: propTypes.string
    }),
    type: propTypes.symbol.isRequired,
    selectMonth: propTypes.func.isRequired,
    disabled: propTypes.bool.isRequired
};

export default DropDownMonth;






